import dynamic from 'next/dynamic';
import { FC } from 'react';
import { translate } from '@/domains/core/localization/translate';
import { reviewsBlockTitle } from '@/domains/productDiscovery/ArticleReviews/translations';
import { economicOperatorDisclaimerTitle } from '@/domains/productDiscovery/EconomicOperatorDisclaimer/translations';
import { deliveryAndReturns } from '@/domains/productDiscovery/ProductPage/common/modules/Delivery/translations';
import { concreteGuaranteeHeader } from '@/domains/productDiscovery/ProductPage/common/modules/GoodToKnow/translations';
import { useSidePanel } from '@/domains/productDiscovery/ProductPage/hooks/useSidePanel';
const DynamicDeliveryOptionsAndSellerReturnCondition = dynamic(async () => (await import('@/domains/productDiscovery/ProductPage/common/modules/Delivery/DeliveryOptionsAndSellerReturnCondition')).DeliveryOptionsAndSellerReturnCondition);
const DynamicProductDescription = dynamic(async () => (await import('@/domains/productDiscovery/ProductPage/common/components/ProductDescription/ProductDescription')).ProductDescription);
const DynamicEconomicOperator = dynamic(async () => (await import('@/domains/productDiscovery/ProductPage/common/components/ProductDescription/EconomicOperator')).EconomicOperator);
const DynamicReview = dynamic(async () => (await import('@/domains/productDiscovery/ProductPage/common/components/Review/Review')).Review);
const DynamicRankingContent = dynamic(async () => (await import('@/domains/productDiscovery/ArticleReviews/modules/reviewsBlock/topRanked/RankingContent')).RankingContent);
const DynamicSidePanel = dynamic(async () => (await import('@/domains/productDiscovery/ProductPage/common/components/SidePanel/SidePanel')).SidePanel);
const DynamicGuarantee = dynamic(async () => (await import('@/domains/productDiscovery/ProductPage/common/components/ConcreteGuarantee/ConcreteGuarantee')).ConcreteGuarantee);
export const {
  descriptionPanelTitle
} = translate({
  "descriptionPanelTitle": "Product information"
});
export const SidePanelContainer: FC = () => {
  const {
    hash,
    sidePanels,
    isSidePanelOpened
  } = useSidePanel();
  if (!isSidePanelOpened) return null;
  if (hash === sidePanels.deliveryAndReturns) {
    return <DynamicSidePanel title={deliveryAndReturns}>
        <DynamicDeliveryOptionsAndSellerReturnCondition />
      </DynamicSidePanel>;
  }
  if (hash === sidePanels.description) {
    return <DynamicSidePanel title={descriptionPanelTitle}>
        <DynamicProductDescription />
      </DynamicSidePanel>;
  }
  if (hash === sidePanels.economicOperator) {
    return <DynamicSidePanel title={economicOperatorDisclaimerTitle} backNavigation>
        <DynamicEconomicOperator />
      </DynamicSidePanel>;
  }
  if (hash === sidePanels.review) {
    return <DynamicSidePanel title={reviewsBlockTitle}>
        <DynamicReview />
      </DynamicSidePanel>;
  }
  if (hash.includes(sidePanels.ranking)) {
    const id = Number(hash.split('-').at(2));
    return <DynamicSidePanel title={reviewsBlockTitle} backNavigation>
        <DynamicRankingContent mdScoreId={id} />
      </DynamicSidePanel>;
  }
  if (hash === sidePanels.concreteGuarantee) {
    return <DynamicSidePanel title={concreteGuaranteeHeader}>
        <DynamicGuarantee />
      </DynamicSidePanel>;
  }
};